import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Клиентские UI-настройки, не требующие сервера.
 * - mentionHighlightColor: цвет подсветки @myUsername (IRC classic + bubble @mentions).
 */
interface UiPrefsState {
  mentionHighlightColor: string;
  setMentionHighlightColor: (c: string) => void;
}

export const MENTION_COLOR_PRESETS = [
  '#5b21b6', // фиолетовый — дефолт
  '#b91c1c', // красный
  '#047857', // зелёный
  '#b45309', // янтарный
  '#0e7490', // бирюзовый
];

export const useUiPrefsStore = create<UiPrefsState>()(
  persist(
    (set) => ({
      mentionHighlightColor: '#5b21b6',
      setMentionHighlightColor: (c) => set({ mentionHighlightColor: c }),
    }),
    { name: 'irchat-ui-prefs' },
  ),
);
